import { useContext } from "react";
import { getById } from "sprint-common-web";

import { DeliveryEndpointType } from "../../../../common/types/DeliveryEndpointType";
import { useAdminDeliveryEndpointApi } from "../../api/useAdminDeliveryEndpointApi";
import { useSigniantStorageEndpoints } from "../../common/useSigniantStorageEndpoints";
import { DeliveryEndpointContext } from "../../context/DeliveryEndpointContext";
import { EditSigniantDeliveryEndpointFormInputs } from "./EditSigniantDeliveryEndpointForm";

export const useEditSigniantDeliveryEndpointForm = (deliveryEndpointId: string) => {
    const { updateDeliveryEndpoint } = useAdminDeliveryEndpointApi();
    const { storageProfiles, isLoading } = useSigniantStorageEndpoints();

    const { deliveryEndpointItems, updateSigniantDeliveryEndpointItem } = useContext(DeliveryEndpointContext);

    const deliveryEndpoint = getById(deliveryEndpointItems, deliveryEndpointId);

    const editDeliveryEndpoint = async ({
        name,
        profileId,
        distributionEmail
    }: EditSigniantDeliveryEndpointFormInputs): Promise<void> => {
        const destinationStorageProfile = getById(storageProfiles, profileId);
        await updateDeliveryEndpoint({
            id: deliveryEndpointId,
            name,
            destinationStorageProfile,
            distributionEmail,
            type: DeliveryEndpointType.Signiant
        });

        updateSigniantDeliveryEndpointItem({
            id: deliveryEndpointId,
            name,
            details: { type: DeliveryEndpointType.Signiant, destinationStorageProfile, distributionEmail },
            type: DeliveryEndpointType.Signiant,
            updatedDate: new Date().toISOString()
        });
    };

    return {
        deliveryEndpoint,
        editDeliveryEndpoint,
        storageProfiles,
        isLoading
    };
};
